import SmoothScroll from 'smooth-scroll'
import Navigation from './lib/navigation'
import Accordion from './lib/accordion'
import Splide from '@splidejs/splide'

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: false,
  offset: (anchor, toggle) => {
    if(toggle.href == '#'){
      return 0
    }else{
      const headerHeight = document.querySelector('.header') ?
        document.querySelector('.header').offsetHeight : 0;
      return headerHeight
    }
  }
})

Navigation('header-nav-btn', 'body')
Accordion()
Accordion(300, '.header-nav .menu-item-has-children > a', 'next', 'mouseover')

// stickyContent([['scroll-top', 'footer']])

// Splide
const options = {
  // perMove: 1,
  easing: 'linear',
  drag: true,
  pagination: false,
}

if(document.getElementById('mainSlide')) {
  const mainSlideOptions = {
    ...options,
    type: 'fade',
    arrows: true,
    mediaQuery: 'max',
    perPage: 1,
    focus: "center",
    breakpoints: {
      750: {
        arrows: false,
      },
    },
  }
  new Splide( '#mainSlide', mainSlideOptions ).mount()
}


if(document.getElementById('topItems')) {
  const itemOptions = {
    ...options,
    mediaQuery: 'min',
    perPage: 1,
    gap: '10%',
    padding: { left: '10%', right: '10%' },
    arrows: false,
    focus: "center",
    breakpoints: {
      751: {
        destroy: true,
      },
      600: {
        perPage: 2,
      },
    },
  }
  new Splide( '#topItems', itemOptions ).mount()
}
